export default __webpack_public_path__ + "static/media/T750MANC6.894ad79e.pdf";